(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enigmae-christmas-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('enigmae-christmas')){
customElements.define('enigmae-christmas',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;
 this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
 this.select=this.querySelector('[data-variant]');
 this.thumbs=[...this.querySelectorAll('[data-photo]')];
 this.isNN=this.dataset.kind==='naughtynest';
 this.nnI18n=(()=>{const el=this.querySelector('[data-nn-i18n]');return el?JSON.parse(el.textContent):{}})();
 if(this.select) this.select.addEventListener('change',()=>this.updateVariant());
 this.thumbs.forEach(b=>b.addEventListener('click',()=>this.showImage(b)));
 this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>{const i=this.thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true');this.showImage(this.thumbs[(Math.max(i,0)+Number(b.dataset.direction)+this.thumbs.length)%this.thumbs.length])}));
 const form=this.querySelector('.xm-form');
 if(form){
   const stickyTarget=this.querySelector('[data-submit]')||form;
   this.observer=new IntersectionObserver(([entry])=>{const sticky=this.querySelector('[data-sticky]');if(!sticky)return; if(this.isNN){ sticky.hidden=false; return; } const below=entry.boundingClientRect.bottom<80; sticky.hidden=entry.isIntersecting&&!below;},{threshold:[0,0.01,1],rootMargin:'-80px 0px 0px 0px'});
   this.observer.observe(stickyTarget);
 }
 if(this.isNN){ this.initNaughtyNest(); this.suppressOverlays(); }
}
disconnectedCallback(){this.observer?.disconnect();this.ready=false}
initNaughtyNest(){
 const sticky=this.querySelector('[data-sticky]');
 if(sticky) sticky.hidden=false;
 const stickyBtn=this.querySelector('[data-sticky-submit]');
 if(stickyBtn) stickyBtn.addEventListener('click',()=>{ const form=this.querySelector('.nn-form'); if(form) form.requestSubmit?form.requestSubmit():form.submit(); });
 this.design=this.select?.selectedOptions?.[0]?.dataset.design || this.variants.find(v=>String(v.id)===this.select?.value)?.design;
 this.size=this.select?.selectedOptions?.[0]?.dataset.size || this.variants.find(v=>String(v.id)===this.select?.value)?.size || 'M';
 this.querySelectorAll('[data-design-value]').forEach(btn=>btn.addEventListener('click',()=>{
   this.design=btn.dataset.designValue;
   this.querySelectorAll('[data-design-value]').forEach(b=>b.setAttribute('aria-selected',String(b===btn)));
   const label=this.querySelector('[data-design-label]'); if(label) label.textContent=this.design;
   this.syncSizeAvailability();
   this.applySelection();
 }));
 this.querySelectorAll('[data-size-value]').forEach(btn=>btn.addEventListener('click',()=>{
   this.size=btn.dataset.sizeValue;
   this.querySelectorAll('[data-size-value]').forEach(b=>b.setAttribute('aria-selected',String(b===btn)));
   this.applySelection();
 }));
 this.querySelectorAll('[data-bundle-qty]').forEach(input=>input.addEventListener('change',()=>this.applyBundle()));
 this.syncSizeAvailability();
 this.applyBundle();
 this.applySelection();
}
syncSizeAvailability(){
 const sizes=[...this.querySelectorAll('[data-size-value]')];
 sizes.forEach(btn=>{
   const ok=this.variants.some(v=>v.design===this.design && v.size===btn.dataset.sizeValue && v.available);
   btn.disabled=!ok;
 });
 const current=sizes.find(b=>b.dataset.sizeValue===this.size);
 if(current?.disabled){
   const fallback=sizes.find(b=>!b.disabled && b.dataset.sizeValue==='M') || sizes.find(b=>!b.disabled);
   if(fallback){ this.size=fallback.dataset.sizeValue; sizes.forEach(b=>b.setAttribute('aria-selected',String(b===fallback))); }
 }
}
applyBundle(){
 const picked=this.querySelector('[data-bundle-qty]:checked');
 const qty=picked?Number(picked.dataset.bundleQty||1):2;
 const qtyInput=this.querySelector('[data-qty]');
 if(qtyInput) qtyInput.value=String(qty);
 this.querySelectorAll('.nn-tier').forEach(t=>t.classList.toggle('is-selected', !!t.querySelector('[data-bundle-qty]:checked')));
 this.updateAtcLabel();
}
applySelection(){
 const match=this.variants.find(v=>v.design===this.design && v.size===this.size) || this.variants.find(v=>v.design===this.design);
 if(!match || !this.select) return;
 this.select.value=String(match.id);
 const hidden=this.querySelector('[data-variant-input]');
 if(hidden) hidden.value=String(match.id);
 this.updateVariant(match);
}
updateAtcLabel(v){
 if(!this.isNN) return;
 const variant=v || this.variants.find(x=>String(x.id)===this.select?.value);
 const btn=this.querySelector('[data-submit]');
 const label=this.querySelector('[data-atc-label]');
 if(!btn || !label || !variant) return;
 if(!variant.available){ label.textContent=this.dataset.sold || this.nnI18n.sold || 'Sold out'; btn.disabled=true; return; }
 btn.disabled=false;
 const tpl=this.nnI18n.cta || 'Add to Cart — {price}';
 label.textContent=tpl.replace('{price}', variant.price);
}

suppressOverlays(){
 const hide=el=>{ try{ el.style.setProperty('display','none','important'); el.style.setProperty('visibility','hidden','important'); el.setAttribute('aria-hidden','true'); }catch(e){} };
 const kill=()=>{
  document.querySelectorAll('[class*="omnisend"],[data-omnisend-form],iframe[src*="omnisend"],[class*="vtl-su"],[id*="vtl-su"],[class*="vtl-fg"],[id*="vtl-fg"],.jdgm-revs-tab,[aria-label*="floating reviews" i],.ts-floating-btn,[class*="vd-gift"],[id*="free-gift"],[class*="free-gift"]').forEach(el=>{
   if(el.closest && el.closest('enigmae-christmas')) return;
   hide(el);
  });
  // Catch fixed right-rail gift launchers (Vitals etc.)
  document.querySelectorAll('body *').forEach(el=>{
   if(el.closest && (el.closest('enigmae-christmas') || el.closest('.xm-sticky') || el.closest('[class*="crisp"]') || el.closest('#crisp-chatbox') || el.closest('[class*="chat"]'))) return;
   const st=window.getComputedStyle(el);
   if(st.position!=='fixed') return;
   const r=el.getBoundingClientRect();
   if(r.width<20||r.width>120||r.height<20||r.height>120) return;
   if(r.right < window.innerWidth-140 || r.bottom < window.innerHeight-220) return;
   const txt=(el.getAttribute('aria-label')||'')+(el.className||'')+(el.id||'')+(el.textContent||'');
   if(/gift|present|reward|bonus/i.test(txt) || el.querySelector('svg') && /gift/i.test(el.innerHTML)) hide(el);
  });
 };
 kill();
 const mo=new MutationObserver(kill);
 mo.observe(document.documentElement,{childList:true,subtree:true});
 setTimeout(()=>mo.disconnect(),15000);
}
showImage(b){if(!b)return;const photo=this.querySelector('.xm-main-photo');const change=()=>{photo.removeAttribute('srcset');photo.src=b.dataset.photo;photo.alt=b.dataset.alt;this.thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===b)))};if(document.startViewTransition&&!matchMedia('(prefers-reduced-motion: reduce)').matches)document.startViewTransition(change);else change()}
updateVariant(forced){
 const v=forced || this.variants.find(v=>String(v.id)===this.select.value);
 if(!v)return;
 const priceEl=this.querySelector('[data-price]'); if(priceEl) priceEl.textContent=v.price;
 const sticky=this.querySelector('[data-sticky-price]'); if(sticky) sticky.textContent=v.price;
 const compare=this.querySelector('[data-compare]');
 if(compare){ compare.hidden=!v.onSale; compare.textContent=v.compare; }
 const save=this.querySelector('[data-save]');
 if(save){
   if(v.onSale && v.compareCents>v.priceCents){
     const amount=((v.compareCents-v.priceCents)/100).toFixed(2);
     const symbol=(String(v.price).match(/[^\d.,\s\u00a0]/g)||['$']).join('') || '$';
     const formatted=symbol + amount;
     const tpl=this.nnI18n.youSave || 'You save {amount}';
     save.textContent=tpl.replace('{amount}', formatted);
     save.hidden=false;
   } else if(this.isNN){
     save.hidden=true;
   }
 }
 const button=this.querySelector('[data-submit]');
 if(button){
   button.disabled=!v.available;
   if(this.isNN) this.updateAtcLabel(v);
   else {
     const span=button.querySelector('span');
     if(span) span.textContent=v.available?this.dataset.add:this.dataset.sold;
   }
 }
 const avail=this.querySelector('[data-availability]');
 if(avail) avail.textContent=v.available?this.dataset.available:this.dataset.sold;
 const thumbnail=this.thumbs.find(t=>t.dataset.imageId===String(v.imageId));
 if(thumbnail)this.showImage(thumbnail);
 const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["enigmae-product-option"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const option=event.target.closest('#ecp-main-swatches .esk-colour');
  if(!option)return;
  option.parentElement.querySelectorAll('.esk-colour').forEach(button=>button.setAttribute('aria-pressed',String(button.classList.contains('is-active'))));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["enigmae-skincare-story"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-esk-scroll]');
  if (!button) return;
  const track = button.closest('.esk-video-section').querySelector('.esk-video-track');
  track.scrollBy({left: Number(button.dataset.eskScroll) * 252, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
document.addEventListener('play', event => {
  if (!event.target.matches('.esk-reel')) return;
  document.querySelectorAll('.esk-reel').forEach(video => { if (video !== event.target && video.pause) video.pause(); });
}, true);
  } catch(e) { console.error(e); }
})();

})();
